import { Grid2 as Grid } from "@mui/material"
import Button from "@mui/material/Button"
import { Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { Donatore } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { useTranslation } from "react-i18next"
import { ACTag, ACTagMulti } from "./autocompletes"

export default function UnificaTagsForm({ save, ref }: FormInDialogProps<Donatore>) {
  const { t } = useTranslation()
  const initialValues = useMemo(() => {
    return {
      tag_da_mantenere: "",
      tags_da_eliminare: [],
    }
  }, [])

  const schema = useMemo(
    () =>
      yup.object().shape({
        tag_da_mantenere: yup.string().required().label(t("tag.tag_da_mantenere")),
        tags_da_eliminare: yup.array().of(yup.string()).required().label(t("tag.tags_da_eliminare")),
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as any).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={12}>
                <ACTag
                  label={t("tag.tag_da_mantenere")}
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  value={Number(values.tag_da_mantenere)}
                  onChange={(value) => {
                    setFieldValue("tag_da_mantenere", value)
                  }}
                />
              </Grid>
              <Grid size={12}>
                <ACTagMulti
                  label={t("tag.tags_da_eliminare")}
                  fullWidth
                  excludeId={Number(values.tag_da_mantenere)}
                  margin="dense"
                  variant="outlined"
                  value={values.tags_da_eliminare || []}
                  onChange={(value) => {
                    setFieldValue("tags_da_eliminare", value)
                  }}
                />
              </Grid>
            </Grid>

            <Button
              disabled={!values.tag_da_mantenere || values.tags_da_eliminare.length === 0}
              ref={ref}
              type="submit"
              color="primary"
              sx={{ display: "none" }}
            ></Button>
          </form>
        )
      }}
    </Formik>
  )
}
